var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60525 2H4.60443C3.16604 2 2 3.16605 2 4.60443C2 6.04282 3.16604 7.20887 4.60443 7.20887H4.60525C6.04364 7.20887 7.20968 6.04282 7.20968 4.60443C7.20968 3.16605 6.04364 2 4.60525 2Z",
    fill: "#35087F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 2H12.0012C10.5628 2 9.39679 3.16605 9.39679 4.60443C9.39679 6.04282 10.5628 7.20887 12.0012 7.20887H12.002C13.4404 7.20887 14.6065 6.04282 14.6065 4.60443C14.6065 3.16605 13.4404 2 12.002 2Z",
    fill: "#FFB3BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.398 2H19.3972C17.9588 2 16.7928 3.16605 16.7928 4.60443C16.7928 6.04282 17.9588 7.20887 19.3972 7.20887H19.398C20.8364 7.20887 22.0024 6.04282 22.0024 4.60443C22.0024 3.16605 20.8364 2 19.398 2Z",
    fill: "#7D0DC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60525 9.39612H4.60443C3.16605 9.39612 2 10.5622 2 12.0006C2 13.4389 3.16605 14.605 4.60443 14.605H4.60525C6.04364 14.605 7.20969 13.4389 7.20969 12.0006C7.20969 10.5622 6.04364 9.39612 4.60525 9.39612Z",
    fill: "#FF5C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 9.39612H12.0012C10.5628 9.39612 9.39679 10.5622 9.39679 12.0006C9.39679 13.4389 10.5628 14.605 12.0012 14.605H12.002C13.4404 14.605 14.6065 13.4389 14.6065 12.0006C14.6065 10.5622 13.4404 9.39612 12.002 9.39612Z",
    fill: "#FFDA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.398 9.39612H19.3972C17.9588 9.39612 16.7928 10.5622 16.7928 12.0006C16.7928 13.4389 17.9588 14.605 19.3972 14.605H19.398C20.8364 14.605 22.0024 13.4389 22.0024 12.0006C22.0024 10.5622 20.8364 9.39612 19.398 9.39612Z",
    fill: "#00FFAA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60525 16.7913H4.60443C3.16605 16.7913 2 17.9573 2 19.3957C2 20.8341 3.16605 22.0001 4.60443 22.0001H4.60525C6.04364 22.0001 7.20969 20.8341 7.20969 19.3957C7.20969 17.9573 6.04364 16.7913 4.60525 16.7913Z",
    fill: "#0080FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 16.7913H12.0012C10.5628 16.7913 9.39679 17.9573 9.39679 19.3957C9.39679 20.8341 10.5628 22.0001 12.0012 22.0001H12.002C13.4404 22.0001 14.6065 20.8341 14.6065 19.3957C14.6065 17.9573 13.4404 16.7913 12.002 16.7913Z",
    fill: "#61CBCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.398 16.7913H19.3972C17.9588 16.7913 16.7928 17.9573 16.7928 19.3957C16.7928 20.8341 17.9588 22.0001 19.3972 22.0001H19.398C20.8364 22.0001 22.0024 20.8341 22.0024 19.3957C22.0024 17.9573 20.8364 16.7913 19.398 16.7913Z",
    fill: "#FF1B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.20a007972b36a51451b5de358032d477.svg";
export { ForwardRef as ReactComponent };